import { render } from "./TrackAndTraceAnixter.vue?vue&type=template&id=12977552&scoped=true"
import script from "./TrackAndTraceAnixter.vue?vue&type=script&lang=js"
export * from "./TrackAndTraceAnixter.vue?vue&type=script&lang=js"

import "./TrackAndTraceAnixter.vue?vue&type=style&index=0&id=12977552&scoped=true&lang=css"

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12977552"]])

export default __exports__